import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import TutionHeader from '../components/header_tution/TutionHeader'
import Footer from '../components/footer/Footer'
import Tution from '../components/tution/Tution'

export default function TutionPage() {
  usePageMeta({
    title: 'Tuition & Rates | Learning In Motion Preschool, Cooper City FL',
    description: 'Tuition and program rates for wobbler, toddler, preschool and VPK programs at Learning In Motion Preschool in Cooper City, FL.',
    path: '/tuition',
  })

  return (
    <>
      <Navbar/>
      <TutionHeader/>
      <Tution/>
      <Footer/>
    </>
  )
}
